// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__KQGP_","cards-container":"styles_cards-container__1ckN9","force-wrap":"styles_force-wrap__1MdxX"};